import { useRouter } from 'next/router';

import type { SitewideFooterProps } from '@motorway/mw-dealer-shared-components/components';
import { SitewideFooter as SharedComponentsSitewideFooter } from '@motorway/mw-dealer-shared-components/components';

import cypressIds from 'Components/cypress_ids.json';
import { triggerSitewideFooterLinkClickEvent } from 'Services/analytics/events/sitewideFooterEvents';
import { isTestEnv } from 'Utilities/helpers';
import useIsAuth from 'Utilities/hooks/useIsAuth';
import { routeWithErrorHandling } from 'Utilities/routes.helpers';
import { shouldUseStaticPageHref } from 'Utilities/staticPageSlugs';

type FooterProps = { beforeFixedBottomBar?: boolean; fixedBottomBarClassName?: string };

type OnLinkClickHandler = NonNullable<SitewideFooterProps['handlers']>['onLinkClick'];

export const SitewideFooter = ({
	beforeFixedBottomBar = false,
	fixedBottomBarClassName = '',
}: FooterProps): React.ReactElement => {
	const isUserAuthed = useIsAuth();
	const router = useRouter();

	const footerConfig: SitewideFooterProps = {
		dataAttributes: { cy: cypressIds.sitewide.footer },
		fixedBottomBar: { beforeFixedBottomBar, fixedBottomBarClassName },
		handlers: {
			onLinkClick: ((e, { as, href, label }) => {
				const asPath = as?.() || href;
				const path = shouldUseStaticPageHref(asPath) ? '/static_page' : href;

				e.preventDefault();
				triggerSitewideFooterLinkClickEvent(label);
				void routeWithErrorHandling(router, { as: asPath, path });
			}) satisfies OnLinkClickHandler,
		},
		isAuth: isUserAuthed,
		isTestEnv,
	};

	return <SharedComponentsSitewideFooter {...footerConfig} />;
};
